import Immutable from 'immutable';
const LOAD = 'help/LOAD';
const LOAD_IMAGES = 'help/LOAD_IMAGES';
const LOAD_SUCCESS = 'help/LOAD_SUCCESS';
const LOAD_IMAGES_SUCCESS = 'help/LOAD_IMAGES_SUCCESS';
const LOAD_FAIL = 'help/LOAD_FAIL';
const LOAD_HELP_LIST = 'help/LOAD_HELP_LIST';
const LOAD_DENTIST_HELP_LIST = 'help/LOAD_DENTIST_HELP_LIST';
const LOAD_SAVE_FORM = 'help/LOAD_SAVE_FORM';
const CLOSE_ERROR_MESSAGE = 'billing/CLOSE_ERROR_MESSAGE';

const initialState = Immutable.fromJS({
  isLoad: false,
  isLoadImages: false,
  loadErr: null,
  loading: false,
  help: null,
  helpList:[],
  helpImages: {},
  dentisthelpList: null
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_IMAGES:
      return state
        .set('isLoadImages', action.res);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('help', action.res);

    case LOAD_IMAGES_SUCCESS:
      return state
        .set('isLoadImages', false)
        .set('helpImages', action.res);

    case LOAD_HELP_LIST:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('helpList', action.res);

    case LOAD_DENTIST_HELP_LIST:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('dentisthelpList', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('schedule', null);

    case LOAD_SAVE_FORM:
      return state
        .set('isLoad', false)
        .set('loadErr', null);

    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const saveForm = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.post(`/udr/help`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const updateForm = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/udr/help`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getHelpList = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let params = '';
  if(id) {
    params = `/${id}`;
  }
  try {
    let res = await api.get(`/udr/help${params}`);
    dispatch({ type: LOAD_HELP_LIST, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getHelpNotifications = (id) => async (dispatch, getState, api) => {
  let user = getState().get('auth').get('user');
  if(!user.id) {
    dispatch({ type: LOAD_FAIL, error: "Failed to get user id." });
  }
  dispatch({ type: LOAD });
  const params = `/${user.id}`;
  try {
    let res = await api.get(`/udr/getHelpNotifications${params}`);
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};


export const updateHelpNotifications = (obj) => async (dispatch, getState, api) => {
  try {
    let res = await api.put(`/udr/updateHelpNotifications`, {data: obj});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};
